import {z} from 'zod';
import {PermissionMatrixSchema} from '@netx/core-permissions/schema';

export enum AssetXMPPacketStatus {
	STORED = 100,
	NOT_STORED_TOO_LARGE = 200,
	NOT_STORED_NO_XMP = 300,
}

export enum AssetStatus {
	UNKNOWN = 0,
	ONLINE = 1,
	NEARLINE = 2,
	OFFLINE = 3,
	TEMP = 4,
	CHECKOUT = 5,
	IMPORT_IN_PROGRESS = 6,
}

export const AssetSchema = z.object({
	assetId: z.number().int().positive(),
	alphaChannel: z.string(),
	attributeIds: z.array(z.number().int().positive()),
	attributeNames: z.array(z.string()),
	attributePermissions: z.array(
		z.union([z.literal('d'), z.literal('r'), z.literal('w')]),
	),
	attributeValues: z.array(z.union([z.string(), z.number()])),
	audioBitRate: z.number().int().positive(),
	audioChannelCount: z.number().int().positive(),
	audioChannelLayout: z.string(),
	audioSampleRate: z.number().int().positive(),
	bitDepth: z.number().int().positive(),
	categories: z.array(z.number().int().positive()),
	categoryid: z.number().int().positive(),
	categoryPaths: z.array(z.string()),
	checkout: z.number().int().positive(),
	checkoutUserLabel: z.string(),
	colorProfile: z.string(),
	commitAttributes: z.boolean(),
	constituentIds: z.array(z.number().int().positive()),
	constituentType: z.string(),
	creationdate: z.string(),
	dpi: z.number().int().positive(),
	duration: z.number().int().positive(),
	expirationDate: z.number().int().positive(),
	file: z.string(),
	fileFormatFamily: z.array(z.string()),
	fileheight: z.number().int().positive(),
	filesize: z.number().int().positive(),
	fileSize2: z.number().int().positive(),
	filetype: z.number().int().positive(),
	filetypelabel: z.string(),
	filewidth: z.number().int().positive(),
	flvPreview: z.boolean(),
	geoLocationLabel: z.string(),
	hidden: z.union([z.literal(0), z.literal(1)]),
	iiifManifestUrl: z.string().nullable(),
	importDate: z.string(),
	importUserLabel: z.string(),
	inCurrentCart: z.boolean(),
	latitude: z.number().int(),
	locationContext: z.string(),
	locationid: z.number().int().positive(),
	longitude: z.number().int(),
	md5sum: z.string(),
	moddate: z.string(),
	moduserid: z.number().int().positive(),
	moduserlabel: z.string(),
	metadataAvailable: z.boolean(),
	name: z.string(),
	path: z.string(),
	permissionMatrix: PermissionMatrixSchema,
	previewHeight: z.number().int().positive(),
	previewUrl: z.string(),
	previewWidth: z.number().int().positive(),
	proofAvailable: z.boolean(),
	rating: z.number().int(),
	readOnly: z.union([z.literal(0), z.literal(1)]),
	relatedAvailable: z.boolean(),
	repurposeAvailability: z.number().int(),
	reviewAvailable: z.boolean(),
	statDeliveries: z.number().int(),
	statPreviews: z.number().int(),
	status: z.nativeEnum(AssetStatus),
	templatable: z.boolean(),
	template: z.boolean(),
	templateCustomizable: z.boolean(),
	thumb: z.string(), // TODO: where did this come from? always empty string
	thumbUrl: z.string(),
	timeScale: z.number().int(),
	versionIds: z.array(z.number().int().positive()),
	viewIds: z.array(z.number().int().positive()),
	viewNames: z.array(z.string()),
	visible: z.union([z.literal(0), z.literal(1)]),
	xmpPacketStatus: z.nativeEnum(AssetXMPPacketStatus),
	zoomAvailable: z.boolean(),

	// Deprecated fields -- do not use!
	imageid: z.number().int().positive(),
	metadata: z.string(),
	attribute1: z.string(),
	attribute2: z.string(),
	attribute3: z.string(),
	attribute4: z.string(),
	attribute5: z.string(),
	attribute6: z.string(),
	attribute7: z.string(),
	attribute8: z.string(),
	attribute9: z.string(),
	attribute10: z.string(),
	attribute11: z.string(),
	attribute12: z.string(),
	attribute13: z.string(),
	attribute14: z.string(),
	attribute15: z.string(),
	attribute16: z.string(),
	hasChildren: z.boolean(),
	parentId: z.number().int().positive(),
});

export type IAsset = z.infer<typeof AssetSchema>;
